import {
  EXCLUSIVE_OFFERS_PAGE_CAMPAIGN_SLUG,
  TILE_TYPE,
} from '@shared/constants';
import getTravellersCount from '@shared/utils/getTravellersCount';
import isProcuredOfferActive from '@shared/utils/isProcuredOfferActive';
import mapOccupants from '@shared/utils/mapOccupants';
import parseProcuredOffer from '@shared/utils/parser/parseProcuredOffer';

const getTotalTravellersAndPrice = (tile, priceForAdult = false) => {
  const { featuredProperty } = tile;
  const { travellers, cheapestOrigin } = featuredProperty;
  const amount = cheapestOrigin?.price?.amount;

  const totalTravellers =
    travellers && getTravellersCount(mapOccupants(featuredProperty.travellers));
  const totalAdults =
    travellers &&
    getTravellersCount(
      mapOccupants({ adults: featuredProperty.travellers.adults }),
    );

  return {
    ...tile,
    featuredProperty: {
      ...featuredProperty,
      travellers: {
        ...travellers,
        total: totalTravellers,
      },
      cheapestOrigin: travellers &&
        amount && {
          ...cheapestOrigin,
          price: {
            total: {
              amount: priceForAdult
                ? amount * totalAdults
                : amount * totalTravellers,
              currency: 'AUD',
            },
            perTraveller: {
              amount,
              currency: 'AUD',
            },
          },
        },
    },
  };
};

const filterActiveProcuredOfferFromTiles = (tiles, slug) =>
  tiles.filter((tile) => {
    if (tile.type !== TILE_TYPE.PROCURED_OFFER) {
      return true;
    }

    return isProcuredOfferActive(
      tile.procuredOffer,
      false,
      slug === EXCLUSIVE_OFFERS_PAGE_CAMPAIGN_SLUG,
    );
  });

const parseCampaign = (campaign) => ({
  ...campaign,
  tiles: filterActiveProcuredOfferFromTiles(campaign.tiles, campaign.slug).map(
    (tile) => {
      switch (tile.type) {
        case TILE_TYPE.FEATURED_PROPERTY:
          return getTotalTravellersAndPrice(tile, campaign.priceForAdult);
        case TILE_TYPE.PROCURED_OFFER:
          return {
            ...tile,
            procuredOffer: parseProcuredOffer(tile.procuredOffer),
          };
        default:
          return tile;
      }
    },
  ),
});

export default parseCampaign;
